export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10756.90b40709.jpg";